import { useState } from "react";
import { motion } from "framer-motion";
import { Plus } from "lucide-react";
import { toast } from "sonner";
import { useCart } from "@/context/CartContext";

const Group = ({ label, options, value, onChange, id }) => (
  <div>
    <p className="f-mono mb-3 text-xs uppercase tracking-[0.2em] text-cacao-2">{label}</p>
    <div className="flex flex-wrap gap-2">
      {options.map((o) => (
        <button
          key={o}
          onClick={() => onChange(o)}
          data-testid={`cupcake-${id}-${o.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
          className={`rounded-full border px-4 py-2 text-sm transition-colors duration-300 ${
            value === o ? "border-[#E11D48] bg-[#E11D48] text-white" : "border-[#F0DDD3] bg-white text-cacao hover:border-[#E11D48]"
          }`}
        >
          {o}
        </button>
      ))}
    </div>
  </div>
);

export const CupcakeBuilder = ({ category }) => {
  const { add } = useCart();
  const b = category.builder;
  const [cake, setCake] = useState(b.cake[0]);
  const [frosting, setFrosting] = useState(b.frosting[0]);
  const [filling, setFilling] = useState(b.filling[0]);

  const name = `${cake} cake, ${frosting} frosting${filling !== "No filling" ? `, ${filling} filling` : ""}`;
  const onAdd = () => {
    add(category.name, name, 1);
    toast.success("Added to your box", { description: name });
  };

  return (
    <div className="space-y-8 rounded-[2rem] border border-[#F0DDD3] bg-[#FFF9F6] p-6 sm:p-8" data-testid="cupcake-builder">
      <Group id="cake" label="01 — Cake flavor" options={b.cake} value={cake} onChange={setCake} />
      <Group id="frosting" label="02 — Frosting" options={b.frosting} value={frosting} onChange={setFrosting} />
      <Group id="filling" label="03 — Filling (optional)" options={b.filling} value={filling} onChange={setFilling} />
      <div className="flex flex-col gap-4 border-t border-[#F0DDD3] pt-6 sm:flex-row sm:items-center sm:justify-between">
        <p className="f-display text-2xl italic text-cacao" data-testid="cupcake-summary">{name}</p>
        <motion.button
          whileTap={{ scale: 0.95 }}
          onClick={onAdd}
          data-testid="cupcake-add-button"
          className="flex shrink-0 items-center justify-center gap-2 rounded-full bg-[#2D1E18] px-6 py-3.5 text-sm font-semibold text-white transition-colors duration-300 hover:bg-[#E11D48]"
        >
          <Plus className="h-4 w-4" /> Add cupcakes
        </motion.button>
      </div>
    </div>
  );
};
